import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { PlanResource } from './Plan';

/**
 * Relationship classes
 */
export class PriceAttributes {
  name: string = null;
  createdAt: string = null;
  id: string = null;
  interval: string = null;
  intervalCount: number = null;
  priceCents: number = null;
  priceCurrency: string = null;
  stripeId: string = null;
  updatedAt: string = null;
}

export class PriceBelongsTo {
  plan: () => PlanResource = () => new PlanResource();
}

export class PriceHasOne {}
export class PriceHasMany {}

/**
 * Utility interfaces
 */
export interface PriceMethods {}

export interface PriceInterface extends PriceAttributes, PriceBelongsTo, PriceType {}

type PriceType = GConstructor<PriceInterface>;

export interface PriceResource extends Base<PriceAttributes>, PriceInterface, PriceMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<PriceAttributes>({
    queryName: 'employers/prices',
    className: 'Price',
    AttributesClass: PriceAttributes,
    BelongsToClasses: [
      {
        Klass: PriceBelongsTo,
      },
    ],
  });

export const PriceResourceClass = <TBase extends PriceType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements PriceMethods {};

export class PriceResource extends ClassExtender<PriceInterface>(BaseClass, PriceResourceClass) {}

/**
 * Resource instance
 */
export const Price = APILibrary.createResource<PriceResource>(PriceResource);
